import type { ExtendedUserMenuData, NavItemConfigInternal, UserMenuData } from '../../types';

export function extendWithCustomizationOptions(
	userMenuData: UserMenuData,
	items: Record<string, NavItemConfigInternal>,
): ExtendedUserMenuData {
	return userMenuData.map((item) => {
		const itemConfig = items[item.menuId];

		if (!itemConfig) {
			return item;
		}

		return {
			...item,
			isNotCustomizable: itemConfig.isReorderable === false,
			isNotToggleable: itemConfig.isHideable === false,
		};
	});
}
